const $ = window.jQuery;

export default new class {
  constructor() {
    this.selectors = {
      modal: '.js-popup-content',
      close: '.js-popup-close',
    };

    this.classes = {
      open: 'is-open',
      locked: 'is-locked',
    };

    this.modal = null;

    $(document).ready(() => {
      if ($(this.selectors.modal).length) {
        this.init();
      }
    });
  }

  init() {
    this.modalOpen();
    this.modalClose();
  }

  modalOpen() {
    $('a').on('click', e => {
      const link = e.currentTarget;
      const href = link.getAttribute('href');

      if (href.substring(0, 1) === '#') {
        const popup = $(`#popup-${href.substr(1)}`);

        if (popup.length) {
          e.preventDefault();
          this.modal = popup;
          $(this.selectors.modal).removeClass(this.classes.open);
          $(this.modal).addClass(this.classes.open);
          $('html').addClass(this.classes.locked);
        }
      }
    });
  }

  modalClose() {
    const closeButton = $(this.selectors.close);

    closeButton.on('click', () => {
      $(this.modal).removeClass(this.classes.open);
      $('html').removeClass(this.classes.locked);
    });
  }
}();



// WEBPACK FOOTER //
// ./wp/wp-content/themes/yanmar-chisel/src/scripts/modules/popup-content.js